/** @jsx h */
import { h, Component } from 'preact'
import PollOrganization from './Organization'
import PollOption from './PollOption'

class Poll extends Component {
  constructor (props) {
    super(props)

    this.state = { showOptions: true }

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (id) {
    this.setState({ showOptions: false })
    const { votingUrl } = this.props
    fetch(votingUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ vote: { option_id: id } })
    })
  }

  render () {
    const { showOptions } = this.state
    const { poll, organization } = this.props
    const { title, options } = poll

    const optionsList = options.map(option =>
      <PollOption {...option} key={option.id} onClick={this.handleClick} />)

    const displayOptions = (
      <div>
        <div class='Poll-title Text-bodySerif u-marginTop20'>{title}</div>
        <p class='Text-bodySansSmall Poll-hint'>Select one</p>
        <div class='Poll-options'>{optionsList}</div>
      </div>
    )

    const displayResults = (
      <div class='Poll-results'>
        <p class='Text-bodySerif'>Thanks for your feedback!</p>
        <PollOrganization {...organization} />
      </div>
    )

    return (
      <div class='Poll'>
        {showOptions ? displayOptions : displayResults}
      </div>
    )
  }
}

export default Poll
